var React = require('react');

function Messages (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.455 13L0 16.5V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H16C16.2652 0 16.5196 0.105357 16.7071 0.292893C16.8946 0.48043 17 0.734784 17 1V13H4.455ZM3.763 11H15V2H2V12.385L3.763 11ZM7 15H17.237L19 16.385V6H20C20.2652 6 20.5196 6.10536 20.7071 6.29289C20.8946 6.48043 21 6.73478 21 7V20.5L16.545 17H8C7.73478 17 7.48043 16.8946 7.29289 16.7071C7.10536 16.5196 7 16.2652 7 16V15Z","fill":"#727281"}));
}

Messages.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = Messages;

Messages.default = Messages;
